import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

const token = () => localStorage.getItem('token');

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = (reader.result as string).split(',')[1];
      resolve(base64data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/**
 * Descarga un PDF protegido (con token) y lo muestra al usuario.
 * En el navegador normal: lo abre en una pestaña nueva.
 * Dentro de la app (Android/iOS): lo guarda temporalmente y abre el
 * diálogo nativo de "Abrir con / Compartir", porque las apps empaquetadas
 * no tienen pestañas nuevas de navegador.
 */
export async function verPDF(url: string, nombreArchivo: string = 'recibo.pdf') {
  try {
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token()}` } });
    if (!r.ok) { alert('No se pudo generar el recibo'); return; }
    const blob = await r.blob();

    if (Capacitor.isNativePlatform()) {
      const base64 = await blobToBase64(blob);
      const resultado = await Filesystem.writeFile({
        path: nombreArchivo,
        data: base64,
        directory: Directory.Cache,
      });
      await Share.share({
        title: 'Recibo',
        url: resultado.uri,
        dialogTitle: 'Abrir o compartir recibo',
      });
    } else {
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    }
  } catch (e) {
    console.error('Error mostrando el PDF', e);
    alert('No se pudo generar el recibo');
  }
}
